import React, {useContext, useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import {PermissionsContext, ErrorContext} from "../utils/constants";
import Colors from "../utils/colors";
import {getData} from "../utils/apiUtils";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import apiFetch from "../utils/apiUtils";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles(() => ({
  h1: {
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  addContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  addArea: {
    width: '45%',
    backgroundColor: Colors.lightBlue,
    padding: '1rem'
  },
  inputStyle: {
    marginTop: '1rem',
    marginBottom: '1rem',
    backgroundColor: 'white'
  },
  tableStyle: {
    border: '1px solid black',
    padding: '1rem'
  },
  table: {
    border: '1px solid black',
    width: '100%',
    marginTop: '3rem'
  },
  chip: {
    margin: '0.5rem'
  }
}));

export default function AdminApproversDashboard() {
  const classes = useStyles();
  const history = useHistory();
  const { isAdmin } = useContext(PermissionsContext);
  const { triggerError } = useContext(ErrorContext);

  if (!isAdmin) {
    history.push('/ui/errors/error404');
  }

  const [ groupAutocompleteList, setGroupAutocompleteList ] = useState([]);
  const [ selectedGroup, setSelectedGroup ] = useState({displayName: ''});
  const [ currentGroupRole, setCurrentGroupRole ] = useState({value: ''});
  const [ userAutocompleteList, setUserAutocompleteList ] = useState([]);
  const [ selectedUser, setSelectedUser ] = useState({displayName: ''});
  const [ currentUserRole, setCurrentUserRole ] = useState({value: ''});
  const [ currentUserGroup, setCurrentUserGroup ] = useState({value: ''});
  const [ currentWorkstream, setCurrentWorkstream ] = useState({value: ''});
  const [ workstreamList, setWorkstreamList ] = useState([]);
  const [ workstreamGroupList, setWorkstreamGroupList ] = useState([]);
  const [ approvers, setApprovers ] = useState([]);
  const [ workstreamRolesList, setWorkstreamRolesList ] = useState([]);

  useEffect(() => {
    const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your approver data from the server. Please try again.',
      onRetry: () => window.location.reload(),
    });

    getData('/users/getApprovers', setApprovers, onError);
    getData('/generaldata/workstreams', processWorkstreams, onError);
    getData('/generaldata/workstreams-groups', setWorkstreamGroupList, onError);
    getData('/generaldata/workstreams-roles', setWorkstreamRolesList, onError);
    document.title = 'Rise by TransAlta Admin Approvers';
  }, [triggerError]);

  const processWorkstreams = (list) => {
    setWorkstreamList(list.filter(ws => !ws.is_disabled));
  };

  const onAutocompleteError = (error) => {
    // deliberately left blank.  We don't want a popup with every letter typed.
    console.log(error);
  };

  const handleGroupAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >=2) {
      getData('/users/' + value, setGroupAutocompleteList, onAutocompleteError);
    }
  };

  const handleUserAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >=2) {
      getData('/users/' + value, setUserAutocompleteList, onAutocompleteError);
    }
  };

  const handleGroupSelect = (event, selectedValue) => {
    if (!selectedValue) {
      return;
    }
    setSelectedGroup(selectedValue);
  };

  const handleUserSelect = (event, selectedValue) => {
    if (!selectedValue) {
      return;
    }
    setSelectedUser(selectedValue);
  };

  const handleGroupRoleChange = (event) => {
    const value = event.target.value;
    const role = workstreamRolesList.find(item => item.id === value);
    setCurrentGroupRole(role);
  };

  const handleWorkstreamChange = (event) => {
    const value = event.target.value;
    const role = workstreamList.find(item => item.id === value);
    setCurrentWorkstream(role);
  };

  const handleUserRoleChange = (event) => {
    const value = event.target.value;
    const role = workstreamRolesList.find(item => item.id === value);
    setCurrentUserRole(role);
  };


  const handleWorksGroupChange = (event) => {
    const value = event.target.value;
    const group = workstreamGroupList.find(item => item.id === value);
    setCurrentUserGroup(group);
  };


  const handleWorkstreamAdd = () => {
    const data = selectedGroup;
    data.role = currentGroupRole.id;
    data.workstream = currentWorkstream.id;
    apiFetch('/users/addsubworkstreamapprover', 'POST',
      JSON.stringify(data),
      (results) => {
        setApprovers(results);
      }, (selectedGroup, currentGroupRole) => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to save u\role ${selectedGroup.displayName} with role ${currentGroupRole}. Please try again.`,
        onRetry: () => handleWorkstreamAdd(),
      }));
  };

  const handleWorkstreamGroupAdd = () => {
    const data = selectedUser;
    data.role = currentUserRole.id;
    data.group = currentUserGroup.id;
    apiFetch('/users/addworkstreamapprover ', 'POST',
      JSON.stringify(data),
      (results) => {
        setApprovers(results);
      }, (selectedUser, currentUserRole) => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to save user ${selectedUser.displayName} with role ${currentUserRole}. Please try again.`,
        onRetry: () => handleWorkstreamGroupAdd(),
      }));
  };

  const handleDelete = (id) => () => {
    apiFetch('/users/approver/' + id, 'DELETE',
      null,
      (results) => {
        setApprovers(results);
      }, () => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to delete the selected card. Please try again.`,
        onRetry: () => handleDelete(id),
      }))
  };

  const getApproverChip = (approver, workstream) => {
      return  <Chip label={approver.workstream_id ? approver.name : `*${approver.name}`}
                    size="small"
                    onDelete={handleDelete(approver.approver_id)}
                    color="primary"
                    key={`${approver.approver_id}-${workstream.id}-tag`}
                    className={classes.chip}
      />;
  };

  const getApproversList = (role, workstream) => {
    return approvers.filter(user => user.role_id === role.id &&
      (workstream.id === user.workstream_id || workstream.group_id === user.group_id));
  };

  const getWorkstreamRow = (workstream) => {
    return (
      <tr key={`row-${workstream.id}`}>
        <td className={classes.tableStyle} key={`workstream-row-${workstream.id}`} id={`workstream-row-${workstream.id}`}>
          {workstream.name}
          </td>
        {workstreamRolesList.map(role =>
          <td className={classes.tableStyle} key={`table-cell-${workstream.id}-${role.id}`} id={`table-cell-${workstream.id}-${role.id}`}>
            {
              getApproversList(role, workstream).map(approver => getApproverChip(approver, workstream))
            }
          </td>
        )}
      </tr>
    );
  };

  return (
    <main>
      <h1 className={classes.h1}>Approver users</h1>
      <div className={classes.addContainer} >
        <div className={classes.addArea}>
          <h2>Add Workstream User</h2>
          <TextField
            id={'text-box-role-user'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'ROLE'}
            onChange={handleUserRoleChange}
            value={currentUserRole.id}
          >
            {workstreamRolesList.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.role}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id={'text-box-group-user'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'Workstream'}
            onChange={handleWorksGroupChange}
            value={currentUserGroup.id}
          >
            {workstreamGroupList.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
          </TextField>
          <Autocomplete
            id={'combo-box-user-1'}
            options={userAutocompleteList}
            getOptionLabel={option => option? option.displayName : ''}
            style={{ width: '100%' }}
            value={selectedUser}
            size="small"
            onChange={handleUserSelect}
            renderInput={params => (
              <TextField {...params}
                         variant="outlined"
                         fullWidth
                         className={classes.inputStyle}
                         onChange={handleUserAutocompleteChange}
                         placeholder="User Name..."
              />
            )}
          />
          <div className={classes.addContainer} >
            <Button
              className={classes.btnStyle}
              variant="contained"
              onClick={handleWorkstreamGroupAdd}
            >
              ADD
            </Button>
          </div>
        </div>

        <div className={classes.addArea}>
          <h2>Add Sub Workstream User</h2>
          <TextField
            id={'text-box-role-group'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'ROLE'}
            onChange={handleGroupRoleChange}
            value={currentGroupRole.id}
          >
            {workstreamRolesList.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.role}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id={'text-box-role-group'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'Sub Workstream'}
            onChange={handleWorkstreamChange}
            value={currentWorkstream.id}
          >
            {workstreamList.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </TextField>
          <Autocomplete
            id={'combo-box-sub-1'}
            options={groupAutocompleteList}
            getOptionLabel={option => option? option.displayName : ''}
            style={{ width: '100%' }}
            value={selectedGroup}
            size="small"
            onChange={handleGroupSelect}
            renderInput={params => (
              <TextField {...params}
                         variant="outlined"
                         fullWidth
                         className={classes.inputStyle}
                         onChange={handleGroupAutocompleteChange}
                         placeholder="User Name..."
              />
            )}
          />

          <div className={classes.addContainer} >
            <Button
              className={classes.btnStyle}
              variant="contained"
              onClick={handleWorkstreamAdd}
            >
              ADD
            </Button>
          </div>
        </div>
      </div>

      <div>
        <h3> Starred (*) entries for the workstreams. Not starred are subworkstream</h3>
        <table className={classes.table}>
          <thead>
          <tr>
            <th className={classes.tableStyle} key="table-header-type">Sub Workstream</th>
            {workstreamRolesList.map(role =>
            <th className={classes.tableStyle} key={`table-header-${role.id}`}>{role.role}</th>
            )}
          </tr>
          </thead>
          <tbody>
          {workstreamList.map(workstream => getWorkstreamRow(workstream) )}
          </tbody>
        </table>
      </div>

    </main>
  );
}
